import React from 'react'

import Button from '@components/Content/Button/Button'
import SliderSection from '@components/Content/Slider/SliderSection'
import FeaturedPostsSlider from '@components/News/FeaturedPostsSlider'
import FeaturedPostsVerticalSection from '@components/News/FeaturedPostsVerticalSection'
import SectionTitle from '@components/Section/SectionTitle'

import { StyledTitleType } from '@contracts/Components/StyledTitle'

import useNewsArchiveLink from '@hooks/useNewsArchiveLink'
import useSiteWidth from '@hooks/useSiteWidth'

import * as styles from './FeaturedPostsSection.module.scss'

const FeaturedPostsSection = () => {
	const siteWidth = useSiteWidth()
	const newsArchiveLink = useNewsArchiveLink()

	const sectionTitle: StyledTitleType = [
		{
			styledText: {
				text: 'Featured',
				isYellow: false,
				isThin: false,
				isSplit: false,
			},
		},
		{
			styledText: {
				text: 'News',
				isYellow: true,
				isThin: false,
				isSplit: false,
			},
		},
	]

	const title = <SectionTitle title={sectionTitle} />
	const slider = <FeaturedPostsSlider />
	const button = (
		<Button
			data={{
				buttonType: 'internal',
				label: 'View all news',
				internalLink: {
					link: newsArchiveLink,
				},
			}}
			style="hollow"
		/>
	)

	if (siteWidth < 767) {
		return <SliderSection title={title} slider={slider} button={button} sectionClassName={styles.section} />
	} else {
		return <FeaturedPostsVerticalSection />
	}
}

export default FeaturedPostsSection
